(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-halloween-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tr-halloween-countdown')) {
  class TrHalloweenCountdown extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      this.controller = new AbortController();
      this.fields = Array.from(this.querySelectorAll('[data-time]'));
      this.status = this.querySelector('[data-copy-status]');
      this.copyButton = this.querySelector('[data-copy-code]');
      this.copyButton?.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(this.copyButton.dataset.copyCode); this.status.textContent = this.status.dataset.copied; }
        catch { this.status.textContent = this.status.dataset.copyFallback; }
      }, { signal: this.controller.signal });
      this.update();
      if (!this.hidden) this.interval = window.setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { window.clearInterval(this.interval); this.controller?.abort(); }
    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!Number.isFinite(this.deadline) || remaining <= 0) { window.clearInterval(this.interval); this.hidden = true; return; }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor((remaining % 86400) / 3600), minutes: Math.floor((remaining % 3600) / 60), seconds: remaining % 60 };
      for (const field of this.fields) { const value = String(values[field.dataset.time]).padStart(2, '0'); if (field.textContent !== value) field.textContent = value; }
    }
  }
  customElements.define('tr-halloween-countdown', TrHalloweenCountdown);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-header"]) return;
  try {
    
(() => {
  function setupCategoryMenu() {
    const menu = document.getElementById('tr-category-menu');
    const toggle = document.querySelector('.tr-menu-toggle');
    if (!menu || !toggle || toggle.dataset.menuReady) return;
    toggle.dataset.menuReady = 'true';
    const close = () => menu.close();
    toggle.addEventListener('click', () => {
      if (menu.open) return;
      menu.showModal();
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tr-menu-is-open');
    });
    menu.querySelector('.tr-menu-close').addEventListener('click', close);
    menu.addEventListener('close', () => {
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tr-menu-is-open');
      toggle.focus({ preventScroll: true });
    });
    menu.addEventListener('click', event => {
      if (event.target.closest('a')) close();
      if (event.target === menu) {
        const rect = menu.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    });
  }
  function setupSearch() {
    const dialog = document.getElementById('tr-search-dialog');
    const toggle = document.querySelector('.tr-search-toggle');
    if (!dialog || !toggle || toggle.dataset.searchReady) return;
    toggle.dataset.searchReady = 'true';
    toggle.addEventListener('click', () => {
      if (dialog.open) return;
      dialog.showModal();
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tr-menu-is-open');
    });
    dialog.querySelector('.tr-search-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tr-menu-is-open');
      toggle.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  }
  setupCategoryMenu();
  setupSearch();
  document.addEventListener('shopify:section:load', () => {
    setupCategoryMenu();
    setupSearch();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-kit-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-card]')];
    const modelSelect = root.querySelector('[data-bike-model]');
    let activeGroup = 'all';
    const supportsModel = card => card.dataset.fitment === 'both' || card.dataset.fitment === modelSelect.value;
    const form = root.querySelector('form');
    const labels = JSON.parse(root.querySelector('[data-kit-labels]').textContent);
    const status = root.querySelector('[data-status]');
    const submit = root.querySelector('[data-submit]');
    const clear = root.querySelector('[data-clear]');
    const list = root.querySelector('[data-summary-list]');
    const money = new Intl.NumberFormat(root.dataset.locale || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });
    let busy = false;
    const format = cents => money.format(cents / 100);
    const selected = () => cards.filter(card => supportsModel(card) && card.querySelector('[data-pick]').checked);
    const option = card => card.querySelector('[data-variant]').selectedOptions[0];
    const applyFilters = () => {
      const groupExists = group => group === 'all' || cards.some(card => supportsModel(card) && card.dataset.group === group);
      if (!groupExists(activeGroup)) activeGroup = 'all';
      root.querySelectorAll('[data-filter]').forEach(button => {
        button.hidden = !groupExists(button.dataset.filter);
        button.setAttribute('aria-pressed', String(button.dataset.filter === activeGroup));
      });
      cards.forEach(card => {
        card.hidden = !supportsModel(card) || (activeGroup !== 'all' && card.dataset.group !== activeGroup);
        card.querySelector('[data-pick]').disabled = busy || !supportsModel(card) || option(card)?.dataset.available !== 'true';
      });
    };
    const update = () => {
      const chosen = selected();
      let total = 0;
      let eligibleTotal = 0;
      list.replaceChildren();
      cards.forEach(card => {
        const pick = card.querySelector('[data-pick]');
        card.classList.toggle('is-selected', pick.checked);
        card.querySelector('[data-pick-label]').textContent = pick.checked ? labels.selected : pick.disabled && !busy ? labels.soldOut : labels.add;
        card.querySelector('.tr-kb-pick-icon').textContent = pick.checked ? '✓' : '+';
        const current = option(card);
        if (current) card.querySelector('[data-price]').textContent = format(Number(current.dataset.price));
      });
      chosen.forEach(card => {
        const current = option(card);
        total += Number(current.dataset.price);
        if (card.dataset.discountEligible !== 'false') eligibleTotal += Number(current.dataset.price);
        const row = document.createElement('li');
        const detail = document.createElement('div');
        const title = document.createElement('span');
        title.className = 'tr-kb-line-title';
        title.textContent = card.dataset.title;
        detail.append(title);
        if (current.textContent.trim() !== 'Default Title') {
          const variant = document.createElement('small');
          variant.textContent = current.textContent.trim();
          detail.append(variant);
        }
        const price = document.createElement('b');
        price.textContent = format(Number(current.dataset.price));
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.disabled = busy;
        remove.className = 'tr-kb-remove';
        remove.textContent = '×';
        remove.setAttribute('aria-label', `${labels.remove} ${card.dataset.title}`);
        remove.addEventListener('click', () => {
          card.querySelector('[data-pick]').checked = false;
          update();
        });
        row.append(detail, price, remove);
        list.append(row);
      });
      root.querySelector('[data-empty]').hidden = chosen.length > 0;
      const count = chosen.length === 1 ? labels.oneCount : chosen.length ? labels.count.replace('[count]', chosen.length) : labels.emptyCount;
      root.querySelector('[data-count]').textContent = count;
      root.querySelector('[data-mobile-count]').textContent = count;
      root.querySelector('[data-total]').textContent = format(total);
      root.querySelector('[data-mobile-total]').textContent = format(total);
      const threshold = 20001;
      const sameCurrency = root.dataset.currency === root.dataset.baseCurrency;
      const unlocked = sameCurrency && eligibleTotal >= threshold;
      const remaining = format(Math.max(0, threshold - eligibleTotal));
      const message = !sameCurrency ? labels.offerCurrency
        : unlocked ? labels.offerUnlocked
        : labels.offerProgress.replace('[amount]', remaining);
      root.querySelectorAll('[data-discount-reward]').forEach(reward => {
        reward.classList.toggle('is-unlocked', unlocked);
        reward.querySelector('[data-offer-status]').textContent = message;
        reward.querySelector('[data-reward-check]').hidden = !unlocked;
        const progress = reward.querySelector('[data-discount-progress]');
        progress.hidden = !sameCurrency;
        progress.value = Math.min(eligibleTotal, threshold);
        progress.setAttribute('aria-valuetext', message);
      });
      const mobileReward = root.querySelector('[data-mobile-reward]');
      if (mobileReward) mobileReward.textContent = !sameCurrency ? labels.offerCurrency
        : unlocked ? labels.offerMobileUnlocked
        : labels.offerMobileProgress.replace('[amount]', remaining);
      const hasPreorder = chosen.some(card => [card.dataset.dispatch, card.dataset.title, option(card)?.textContent || ''].join(' ').toLowerCase().includes('preorder'));
      root.querySelector('[data-shipping]').textContent = !chosen.length ? labels.dispatch : hasPreorder ? labels.preorder : labels.ready;
      submit.disabled = busy || !chosen.length;
      clear.disabled = busy || !chosen.length;
    };
    cards.forEach(card => {
      const pick = card.querySelector('[data-pick]');
      pick.addEventListener('change', () => {
        status.textContent = '';
        if (pick.checked && card.dataset.conflict !== 'none') {
          let removed = false;
          selected().forEach(other => {
            if (other === card) return;
            const type = card.dataset.conflict;
            const conflict = (type === 'hardware-full' && other.dataset.conflict === 'hardware-part') || (type === 'hardware-part' && other.dataset.conflict === 'hardware-full') || (type === 'light' && other.dataset.conflict === 'light');
            if (conflict) {
              other.querySelector('[data-pick]').checked = false;
              removed = true;
            }
          });
          if (removed) status.textContent = card.dataset.conflict === 'light' ? labels.lightConflict : labels.hardwareConflict;
        }
        update();
      });
      card.querySelector('[data-variant]').addEventListener('change', () => {
        const current = option(card);
        const image = card.querySelector('.tr-kb-product-image');
        if (image && current.dataset.image) {
          image.src = current.dataset.image;
          image.removeAttribute('srcset');
        }
        pick.disabled = !supportsModel(card) || current.dataset.available !== 'true';
        if (pick.disabled) pick.checked = false;
        update();
      });
    });
    root.querySelectorAll('[data-filter]').forEach(button => {
      button.addEventListener('click', () => {
        activeGroup = button.dataset.filter;
        applyFilters();
      });
    });
    modelSelect.addEventListener('change', () => {
      let removed = false;
      cards.forEach(card => {
        const pick = card.querySelector('[data-pick]');
        if (!supportsModel(card) && pick.checked) { pick.checked = false; removed = true; }
      });
      status.textContent = removed ? labels.modelChanged : '';
      applyFilters();
      update();
    });
    clear.addEventListener('click', () => {
      cards.forEach(card => { card.querySelector('[data-pick]').checked = false; });
      status.textContent = '';
      update();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !selected().length) return;
      busy = true;
      status.textContent = labels.adding;
      submit.textContent = labels.adding;
      root.querySelectorAll('input, select, [data-filter]').forEach(control => { control.disabled = true; });
      update();
      try {
        const response = await fetch(root.dataset.cartAdd, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selected().map(card => ({ id: option(card).value, quantity: 1, properties: { Kit: labels.kitName, Bike: modelSelect.selectedOptions[0].textContent.trim(), _tr_kit_builder: modelSelect.value } })) })
        });
        const result = await response.json();
        if (!response.ok) {
          const error = new Error(typeof result.description === 'string' ? result.description : labels.error);
          error.confirmed = true;
          throw error;
        }
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.confirmed ? error.message : labels.networkError;
        busy = false;
        submit.textContent = labels.addKit;
        modelSelect.disabled = false;
        root.querySelectorAll('[data-filter]').forEach(control => { control.disabled = false; });
        cards.forEach(card => {
          const picker = card.querySelector('[data-variant]');
          picker.disabled = false;
          card.querySelector('[data-pick]').disabled = !supportsModel(card) || option(card).dataset.available !== 'true';
        });
        update();
      }
    });
    applyFilters();
    update();
  };
  document.querySelectorAll('[data-kit-builder]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kit-builder]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
